import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { Flex, Hr } from '@/ui';
import { AddToCalendarAccessNote } from './AddToCalendarAccessNote';
import { CopyLinkSection } from './CopyLinkSection';
import { PublicLinkToggle } from './PublicLinkToggle';

/**
 * The planner's "anyone with the link" block: the switch, and the link it produces.
 *
 * The switch shows to everyone who can reach the modal, so collaborators can see the
 * page's sharing state — but flipping it is the owner's call, which PublicLinkToggle
 * enforces by rendering the switch read-only for a non-owner.
 */
export const PublicLinkSection = () => {
  const { experience } = usePageExperienceContext();
  const isPublic = experience?.isPublic ?? false;

  return (
    <>
      <Flex direction="column" gap="4">
        <PublicLinkToggle />
        {/* The switch's own label says "can view", so the link below never repeats
            it. The calendar-access heads up sits right under the link so it's the
            first thing seen after turning sharing on (it self-gates to a mismatch). */}
        {isPublic && (
          <>
            <CopyLinkSection hideAccessText />
            <AddToCalendarAccessNote />
          </>
        )}
      </Flex>
      <Hr mx="-8" />
    </>
  );
};
